// Must match SparklineCell's internal margin (xV = 1 in the bundle)
const MARGIN = 1;

/**
 * Replicates SparklineCell's internal `bV()` point computation for type="area" (useMidPoint=false):
 *   yScale = (height - 2 * margin) / (max - min || 2)
 *   xScale = (width - 2 * margin) / (length - 1)
 *   x_i = i * xScale + margin
 *   y_i = (max === 0 && min === 0) ? height - margin : (max - value) * yScale + margin
 */
export const computePoints = (
    data: readonly number[],
    width: number,
    height: number,
    minOverride?: number,
    maxOverride?: number,
) => {
    const min = minOverride ?? Math.min(...data);
    const max = maxOverride ?? Math.max(...data);
    const yScale = (height - MARGIN * 2) / (max - min || 2);
    const xScale = (width - MARGIN * 2) / (data.length - 1);

    return data.map((value, i) => ({
        x: i * xScale + MARGIN,
        y: max === 0 && min === 0 ? height - MARGIN : (max - value) * yScale + MARGIN,
    }));
};

export const buildZoneAreaPath = (points: readonly { x: number; y: number }[], bottomY: number) => {
    const line = points.map((p, i) => `${i === 0 ? "M" : "L"}${p.x},${p.y}`).join(" ");

    return `${line} L${points[points.length - 1].x},${bottomY} L${points[0].x},${bottomY} Z`;
};
